module.exports = __webpack_public_path__ + "static/media/logo-그레이프시티@2x.04b89685.png";